import Grid from "@material-ui/core/Grid";
import { useState } from "react";
import Divider from "./../../../components/Divider/Divider";
import MenuItem from "@material-ui/core/MenuItem";
import TextField from "@material-ui/core/TextField";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import "../Survey.scss";

const SurveyForm = ({ handleChangeField, surveyInfo, readOnly, errorMessage, errorInfo }) => {
  const { t } = useTranslation();

  const ifBuyerIsNotThere = surveyInfo?.SurveyIsBuyerThere === 0;

  return (

    <Grid container spacing={5}>
      <Grid item sm={12}>
        <Divider>{t(`Survey`)}</Divider>
      </Grid>
      <Grid item sm={4}>
        <TextField
          select
          variant="outlined"
          style={{ minWidth: 220 }}
          value={surveyInfo.SurveyIsBuyerThere}
          name="SurveyIsBuyerThere"
          InputLabelProps={{ shrink: true }}
          onChange={handleChangeField}
          label={t(`Buyer Is there`)}
          size="small"
          disabled={readOnly}
          error={!!errorInfo.SurveyIsBuyerThere}
          helperText={t(errorInfo.SurveyIsBuyerThere)}
        >
          <MenuItem value={1}>Yes</MenuItem>
          <MenuItem value={0}>No</MenuItem>
        </TextField>
      </Grid>
      <Grid item sm={4}>
        <TextField
          select
          variant="outlined"
          style={{ minWidth: 220 }}
          name="SurveyModalityReported"
          value={surveyInfo.SurveyModalityReported}
          onChange={handleChangeField}
          InputLabelProps={{ shrink: true }}
          label={t(`Modality Reported`)}
          size="small"
          disabled={readOnly || ifBuyerIsNotThere}
          error={!!errorInfo.SurveyModalityReported}
          helperText={t(errorInfo.SurveyModalityReported)}
        >
          <MenuItem value="A">Active</MenuItem>
          <MenuItem value="P">Passive</MenuItem>
          <MenuItem value="M">Mix</MenuItem>
        </TextField>
      </Grid>

      {surveyInfo.SurveyModalityReported === "M"  && (
        <Grid item sm={4}>
          <TextField
            select
            variant="outlined"
            style={{ minWidth: 220 }}
            name="SurveyMainModality"
            onChange={handleChangeField}
            value={surveyInfo.SurveyMainModality}
            InputLabelProps={{ shrink: true }}
            label={t(`Main Modality`)}
            size="small"
            disabled={readOnly}
            
            error={!!errorInfo.SurveyMainModality}
            helperText={t(errorInfo.SurveyMainModality)}
          >
            <MenuItem value="A">Active</MenuItem>
            <MenuItem value="P">Passive</MenuItem>
          </TextField>
        </Grid>
      )}
      <Grid item sm={4}>
        <TextField
          select
          variant="outlined"
          style={{ minWidth: 220 }}
          value={surveyInfo.RepresentativePresent}
          name="RepresentativePresent"
          onChange={handleChangeField}
          InputLabelProps={{ shrink: true }}
          label={t(`Representative Present`)}
          size="small"
          disabled={readOnly || ifBuyerIsNotThere}
          error={!!errorInfo.RepresentativePresent}
          helperText={t(errorInfo.RepresentativePresent)}
        >
          <MenuItem value={1}>Yes</MenuItem>
          <MenuItem value={0}>No</MenuItem>
        </TextField>
      </Grid>
      {surveyInfo.RepresentativePresent === 1 && (
        <>
          <Grid item sm={4}>
            <TextField
              variant="outlined"
              name="SurveyEZDRepName"
              value={surveyInfo.SurveyEZDRepName}
              label={t("Representative Name")}
              InputLabelProps={{ shrink: true }}
              onChange={handleChangeField}
              size="small"
              disabled={readOnly || ifBuyerIsNotThere}
              error={!!errorInfo.SurveyEZDRepName}
              helperText={t(errorInfo.SurveyEZDRepName)}
            />
          </Grid>

          <Grid container spacing={2} className="survey__form__disclaimer">
            <Grid item sm={12}>
              <Divider>{t(`Disclaimer`)}</Divider>
            </Grid>

            <Grid item sm={12} className="survey__form__disclaimer__text">
              {t(`The products are sold only in compliance with the laws of the
              particular jurisdictions in which they are sold`) + `.`}
            </Grid>
          </Grid>
        </>
      )}
    </Grid>
  );
};

export default SurveyForm;

SurveyForm.propTypes = {
  handleChangeField: PropTypes.func,
  surveyInfo: PropTypes.object,
  readOnly: PropTypes.bool,
  errorMessage: PropTypes.object,
  errorInfo: PropTypes.object
};
